import React from "react";

const ProcessingBar = () => {
  return (
    <>
      <span className="loader" />
      <style>{`
        .loader {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          display: block;
          margin: 5px auto;
          position: relative;
          animation: shadowPulse 1s linear infinite;
        }

        @keyframes shadowPulse {
          33% {
            background: #FFF;
            box-shadow: -24px 0 #991b1b, 24px 0 #FFF;
          }
          66% {
            background: #991b1b;
            box-shadow: -24px 0 #FFF, 24px 0 #FFF;
          }
          100% {
            background: #FFF;
            box-shadow: -24px 0 #FFF, 24px 0 #991b1b;
          }
        }
      `}</style>
    </>
  );
};

export default ProcessingBar;
